module.exports = __webpack_public_path__ + "img/border_horizontal.cb2fe6ec.svg";